module.exports = __webpack_public_path__ + "img/download.5d32d27b.svg";